var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vector3 } from '@babylonjs/core/Maths/math.vector';
import { Entity } from './Entity';
import { EntityMove } from './Entity/EntityMove';
import { EntityNamePlate } from './Entity/EntityNamePlate';
import { BunnySpriteRenderer, SPRITE_WORLD_SIZE } from './Pet/BunnySpriteRenderer';
const MOVE_THRESHOLD = 0.001;
export class Pet extends Entity {
    constructor(name, scene, gamescene, entity) {
        super(name, scene, gamescene, entity);
        this._spriteRenderer = null;
        this._serverRot = 0;
        this._fakeShadow = null;
    }
    spawn(entity) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            this._spriteRenderer = new BunnySpriteRenderer(this._scene);
            try {
                yield this._spriteRenderer.load();
            }
            catch (err) {
                console.error(`Pet: failed to load sprite renderer for entity ${entity.sessionId}:`, err);
                return;
            }
            this._spriteRenderer.setMetadata({ type: 'entity', sessionId: entity.sessionId });
            this.position = new Vector3(entity.x, entity.y, entity.z);
            this._spriteRenderer.setPosition(this.position);
            this.moveController = new EntityMove(this);
            this.moveController.setPositionAndRotation(entity);
            this.nameplateController = new EntityNamePlate(this);
            // getEntityheight() returns hardcoded 1 when there is no mesh, ignoring offset_y.
            // Override so nameplate and chat stack above the sprite.
            // offset_y=0.5 → nameplate, offset_y=1.5 → chat; only boost chat to clear nameplate
            this.nameplateController.getEntityheight = (offset_y) => SPRITE_WORLD_SIZE + offset_y + (offset_y >= 1.0 ? 0.5 : -0.75);
            this.nameplate = this.nameplateController.addNamePlate();
            const shadowAsset = this._game._loadedAssets['DYNAMIC_shadow_01'];
            if (shadowAsset) {
                this._fakeShadow = shadowAsset.createInstance('shadow_' + entity.sessionId);
                this._fakeShadow.parent = this;
                this._fakeShadow.isPickable = false;
                this._fakeShadow.checkCollisions = false;
                this._fakeShadow.doNotSyncBoundingInfo = true;
                this._fakeShadow.position = new Vector3(0, 0.04, 0);
            }
            const rot = (_a = entity.rot) !== null && _a !== void 0 ? _a : 0;
            this._spriteRenderer.playAnimation('idle', rot);
            entity.onChange(() => {
                this._syncFromServer(entity);
            });
        });
    }
    _syncFromServer(entity) {
        var _a, _b;
        this._serverRot = (_a = entity.rot) !== null && _a !== void 0 ? _a : 0;
        (_b = this.moveController) === null || _b === void 0 ? void 0 : _b.setPositionAndRotation(entity);
    }
    update(delta) {
        var _a, _b;
        const prevX = this.position.x;
        const prevZ = this.position.z;
        super.update(delta);
        (_a = this._spriteRenderer) === null || _a === void 0 ? void 0 : _a.setPosition(this.position);
        const dx = this.position.x - prevX;
        const dz = this.position.z - prevZ;
        const isMoving = dx * dx + dz * dz > MOVE_THRESHOLD * MOVE_THRESHOLD;
        const animState = isMoving ? 'walk' : 'idle';
        (_b = this._spriteRenderer) === null || _b === void 0 ? void 0 : _b.playAnimation(animState, this._serverRot);
    }
    remove() {
        var _a, _b;
        (_a = this._spriteRenderer) === null || _a === void 0 ? void 0 : _a.dispose();
        (_b = this._fakeShadow) === null || _b === void 0 ? void 0 : _b.dispose();
        if (this.nameplate) {
            this.nameplate.dispose();
        }
        this.dispose();
    }
}
